import { selector } from '@/lib/selectors';

const currencies = (state) => state.currencies;
export const currenciesListSelector = selector(currencies, (c) => c);
